import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// This city page is not published on the primary site. Preserve the URL with a
// permanent redirect to the state hub instead of serving a duplicate page.
export const Route = createFileRoute("/locations/district-of-columbia/washington-dc")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/district-of-columbia/", location.searchStr), statusCode: 301 });
  },
});
